import {
  LargeHeadingStyled,
  SectionHeaderStyled,
} from "../../../components/custom/texts/texts.styled";
import { Card, Flex, IUploadProps, Icon } from "@nubeteck/components";
import { Button, Table, Upload, Skeleton } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { toastErrorStyle } from "src/constants";
import { FormatterUtils } from "@nubeteck/utils";
import { getFormData } from "src/utils/files-util";
import { Content } from "antd/es/layout/layout";
import { ButtonAlternativeStyled } from "src/components/custom/buttons/buttons.styled";
import { useGetPaymentsComparisonMutation } from "src/services/chargesSettingsServices";
import { getVerifyPayPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { StrapiError } from "../../StrapiError";
import { formatDate } from "src/utils/date-util";

const PaymentsComparison: React.FC = () => {
  const [getPaymentsComparison, { data, isLoading, error }] = useGetPaymentsComparisonMutation();
  const [result, setResult] = useState<any>([]);
  const { locale } = useLocale();
  const [verifyPayPage, setVerifyPayPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError]= useState<boolean>(false);
  useEffect(() => {
    if (error) toast.error(error?.data?.message, toastErrorStyle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    if (data?.data?.pagosExcel?.length > 0) {
      const arrResult: any[] = [];

      data?.data?.pagosExcel.forEach((element: any) => {
        const coincidence = data?.data?.pagosDB?.find(
          (pago: any) => pago?.pagoId == element?.pagoIdMatch,
        );
        console.log(coincidence, "coincidence");
        arrResult.push({
          ...element,
          ...coincidence,
          fechaFormateadaDb: coincidence?.fecha,
        });
      });
      // const other = data?.data?.pagosDB?.filter(
      //   (pago: any) => !arrResult.find((el) => el.pagoId === pago.pagoId),
      // );
      // arrResult = arrResult.concat(other);
      setResult(arrResult);
    }
  }, [data]);

  console.log(result, "result");
  const rowClassName = (record: any) => {
    return record?.pagoIdMatch ? "row-match" : "";
  };

  const descargarExcel: (fileName: string, data: string) => void = (fileName, data) => {
    const aElement = document.createElement("a");
    aElement.setAttribute("download", fileName);
    const href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data}`;
    aElement.href = href;
    aElement.setAttribute("target", "_blank");
    aElement.click();
    URL.revokeObjectURL(href);
  };

  const columnsExcel = React.useMemo<ColumnsType<any>>(
    () => [
      {
        title: verifyPayPage?.excel_payments_group_title || "Pagos en el excel",
        children: [
          {
            title: verifyPayPage?.excel_payments_table?.[0]?.label || "No.",
            dataIndex: "numeroPedido",
          },
          {
            title: verifyPayPage?.excel_payments_table?.[1]?.label || "Fecha",
            dataIndex: "fechaRegistro",
            width: 100,
            render: (value) => formatDate(value),
          },
          {
            title: verifyPayPage?.excel_payments_table?.[2]?.label || "Nombre",
            dataIndex: "nombres",
            width: 250,
            render: (value, record) => `${value} ${record.apellidos}`,
          },
          {
            title: verifyPayPage?.excel_payments_table?.[3]?.label || "Monto",
            dataIndex: "monto",
            width: 150,
            render: (value: number) => FormatterUtils.number(value?.toFixed(2)),
          },
          {
            title: verifyPayPage?.excel_payments_table?.[4]?.label || "Moneda",
            dataIndex: "moneda",
            width: 150,
          },
          {
            title: verifyPayPage?.excel_payments_table?.[5]?.label || "No. tarjeta",
            dataIndex: "numeroTarjeta",
            width: 150,
          },
          {
            title: verifyPayPage?.excel_payments_table?.[6]?.label || "Marca tarjeta",
            dataIndex: "marca",
            width: 150,
          },
          {
            dataIndex: "codigoAutorizacion",
            title: verifyPayPage?.excel_payments_table?.[7]?.label || "Codigo de autorización",
            width: 80,
          },
          {
            title: verifyPayPage?.excel_payments_table?.[8]?.label || "Estado",
            dataIndex: "estado",
            width: 100,
          },
        ],
      },

      {
        title: <Icon name="" size={26} color="#00479B" />,
        dataIndex: "pagoIdMatch",
        render: (value: any) => {
          return {
            children: (
              <div>
                {value ? (
                  <Icon name="" size={16} color="#00479B" />
                ) : (
                  <Icon name="" size={16} color="#d00000" />
                )}
              </div>
            ),
            props: {
              style: { backgroundColor: "white" },
            },
          };
        },
        width: 60,
      },

      {
        title: verifyPayPage?.system_payments_group_title || "Pagos en el sistema",
        children: [
          {
            title: verifyPayPage?.system_payments_table?.[3]?.label || "Recibo",
            dataIndex: "reciboId",
          },
          {
            title: verifyPayPage?.system_payments_table?.[4]?.label || "Referencia",
            dataIndex: "referencia",
          },
          {
            title: verifyPayPage?.system_payments_table?.[0]?.label || "Fecha",
            dataIndex: "fechaFormateadaDb",
            width: 100,
            render: (value) => formatDate(value) || value,
          },
          {
            title: verifyPayPage?.system_payments_table?.[1]?.label || "Nombre",
            dataIndex: "terceroNombre",
            width: 250,
          },
          {
            title: verifyPayPage?.system_payments_table?.[2]?.label || "Moneda",
            dataIndex: "monedaNombre",
            width: 100,
          },
        ],
      },
    ],
    [verifyPayPage],
  );

  const props: IUploadProps = {
    name: "model",
    multiple: false,
    showUploadList: false,
    maxCount: 1,
    beforeUpload: () => false,
    accept: "*",
  };

  const onChangeExcel = (file: any) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result !== null)
        fetch(reader.result as string).then((res) =>
          res.blob().then((blob) => {
            getPaymentsComparison(getFormData({ file: blob }));
          }),
        );
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setVerifyPayPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    getVerifyPayPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setVerifyPayPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setVerifyPayPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setVerifyPayPage(null);
      }}
    />;
  }
  
  return (
    <Flex style={{ flexDirection: "column", width: "100%", alignSelf: "flex-start" }}>
      <LargeHeadingStyled>{isLoadingContent ? <Skeleton.Input active size="large" style={{ width: 300 }} /> : (verifyPayPage?.title || "Verificación de pagos")}</LargeHeadingStyled>
      <Content style={{ marginTop: "16px" }}>
        {data?.data?.pagosExcel?.length > 0 ? (
          <SectionHeaderStyled style={{ paddingBottom: 7 }}>
            <Upload
              {...props}
              disabled={isLoading}
              onChange={(info) => {
                const { status } = info.file;
                if (status !== "uploading") {
                  onChangeExcel(info.file);
                }
              }}
            >
              <Button icon={<Icon name="" size={13} color="#00479B" />}>{isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (verifyPayPage?.uploadanother_button || "Subir otro excel")}</Button>
            </Upload>
            <Button
              title=""
              type="primary"
              onClick={() => {
                const now = new Date();
                const fecha = now
                  .toLocaleDateString("es-CR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })
                  .replace(/\//g, "-");
                const hora = now
                  .toLocaleTimeString("es-CR", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  })
                  .replace(/:/g, "");
                descargarExcel(`VerifPagos_${fecha}_${hora}.xlsx`, data?.data?.excelComparado);
              }}
            >
              {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (verifyPayPage?.export_button || "Exportar pagos")}
            </Button>
          </SectionHeaderStyled>
        ) : null}

        <Card bodyStyle={{ padding: 0, width: "100%" }} style={{ width: "100%" }}>
          <Table<any>
            bordered
            showHeader={data?.data?.pagosExcel?.length > 0}
            rowClassName={rowClassName}
            locale={{
              emptyText: (
                <>
                  <Upload
                    {...props}
                    disabled={isLoading}
                    onChange={(info) => {
                      const { status } = info.file;
                      if (status !== "uploading") {
                        onChangeExcel(info.file);
                      }
                    }}
                  >
                    <ButtonAlternativeStyled
                      size="large"
                      icon={<Icon name="" size={16} color="#00479B" />}
                    >
                      {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (verifyPayPage?.update_button || "Subir excel")}
                    </ButtonAlternativeStyled>
                  </Upload>
                  <br />
                  <p style={{ color: "#8d8d8d" }}>
                    {isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 300 }} /> : (verifyPayPage?.description || "Suba un archivo de excel para mostrar las comparaciones entre los pagos realizados y los pagos reportados.")}
                  </p>
                </>
              ),
            }}
            loading={isLoading}
            columns={columnsExcel}
            dataSource={result}
            rowKey={(v) => `${v?.identificador} ${v?.pagoId}`}
            pagination={{
              defaultPageSize: 15,
              showSizeChanger: true,
              style: { marginRight: "30px" },
            }}
            scroll={{ x: 200 }}
          />
        </Card>
      </Content>
    </Flex>
  );
};

export default PaymentsComparison;
